import { getAuthReducer } from '@cibo/profile'
import { composeWithDevTools } from '@redux-devtools/extension'
import { Store, applyMiddleware, combineReducers, createStore } from 'redux'
import { persistReducer } from 'redux-persist'
import thunkMiddleware from 'redux-thunk'
import { storage } from './defaultStorage'

const authReducerConfig = {
  key: 'auth',
  storage,
  whitelist: ['environmentAccess'],
  blacklist: ['session'],
}

const middlewares = [thunkMiddleware]
const middleWareEnhancer = applyMiddleware(...middlewares)

const store: Store = createStore(
  combineReducers({
    authReducer: persistReducer(authReducerConfig, getAuthReducer(storage)),
  }),
  composeWithDevTools(middleWareEnhancer)
)

export { store }
